<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>الاصناف</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة صنف</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        disabled
                        v-model="mycode"
                        label="كود الصنف"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.code')"
                        data-vv-name="code"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.name"
                        label="أسم الصنف"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.price_buy"
                        label=" سعر الشراء"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.price_sell"
                        label=" سعر البيع"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm6 md4>
                    <v-text-field v-model="newItem.item_bonus" label="الزيادة"  ></v-text-field>
                  </v-flex> -->
                    <!-- <v-flex xs12 sm6 md4>
                    <v-text-field v-model="newItem.num" label=" مجمو "  ></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_store"
                    :items="stores"
                    item-text="name"
                    item-value="id"
                    label="أختر المخزن"
                    persistent-hint
                    return-object
                    single-line
                     v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')" data-vv-name="manger" data-vv-scope="form1"
                ></v-select>
                  </v-flex> -->
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_group"
                        :items="groups"
                        item-text="name"
                        item-value="id"
                        label="أختر  المجموعة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <material-picker v-model="colors" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل صنف</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      disabled
                      v-model="editedItem.code"
                      label="كود الصنف"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.code')"
                      data-vv-name="code"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.name"
                      label="أسم الصنف"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.price_buy"
                      label="سعر الشراء "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.price_sell"
                      label="سعر البيع "
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.item_bonus" label="الزيادة  "  ></v-text-field>
                  </v-flex> -->
                  <!-- <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.num" label=" العدد "  ></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_store_edit"
                    :items="stores"
                    item-text="name"
                    item-value="id"
                    label="أختر المخزن"
                    persistent-hint
                    return-object
                    single-line
                     v-validate="'required'"
                        :error-messages="errors.collect('form2.manger')" data-vv-name="manger" data-vv-scope="form2"
                ></v-select>
                  </v-flex> -->
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_group_edit"
                      :items="groups"
                      item-text="name"
                      item-value="id"
                      label="أختر  المجموعة"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="change_color"
                      label="تغير اللون"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex
                    style="float:right"
                    xs12
                    sm12
                    md12
                    v-show="change_color"
                  >
                    <material-picker v-model="edit_colors" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td :style="{ 'background-color': props.item.item_color }">
            {{ props.item.code }}
          </td>
          <td :style="{ 'background-color': props.item.item_color }">
            {{ props.item.name }}
          </td>
          <td
            :style="{ 'background-color': props.item.item_color }"
            class="text-xs-right"
          >
            {{ props.item.price_buy }}
          </td>
          <td
            :style="{ 'background-color': props.item.item_color }"
            class="text-xs-right"
          >
            {{ props.item.price_sell }}
          </td>
          <td
            :style="{ 'background-color': props.item.item_color }"
            class="justify-center layout px-0"
          >
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              class="ml-4"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  items,
  add_item,
  update_item,
  delete_item,
  stores,
  groups
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "كود الصنف",
        align: "right",
        value: "name"
      },
      {
        text: "أسم الصنف",
        align: "right",
        value: "name"
      },
      { text: "سعر الشراء", value: "price_buy", align: "right" },
      { text: "سعر البيع", value: "price_sell", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    select_store: { id: "", job_name: "", name: "أختر المخزن" },
    select_group: { id: "", job_name: "", name: "أختر المجموعة " },
    select_store_edit: { id: "", job_name: "", name: "أختر المخزن" },
    select_group_edit: { id: "", job_name: "", name: "أختر المجموعة " },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    colors: {
      hex: "#194d33",
      hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
      hsv: { h: 150, s: 0.66, v: 0.3, a: 1 },
      rgba: { r: 25, g: 77, b: 51, a: 1 },
      a: 1
    },
    edit_colors: {
      hex: "",
      hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
      hsv: { h: 150, s: 0.66, v: 0.3, a: 1 },
      rgba: { r: 25, g: 77, b: 51, a: 1 },
      a: 1
    },
    change_color: false,
    items: [],
    stores: [],
    groups: [],
    editedItem: {
      id: "",
      code: "",
      name: "",
      price_buy: "",
      price_sell: "",
      item_color: "",
      group_id: ""
    },
    newItem: {
      id: "",
      code: "",
      name: "",
      price_buy: "",
      price_sell: "",
      item_color: "",
      group_id: ""
    }
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.items.length > 0) {
        return (this.code =
          parseInt(this.items[this.items.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();

    items().then(response => {
      this.items = response.data;
      this.pagination.totalItems = response.data.length;
      this.loading = false;
    });
  },

  methods: {
    initialize() {
      stores().then(response => {
        this.stores = response.data;
      });

      groups().then(response => {
        this.groups = response.data;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.items.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.price_buy = item.price_buy;
      this.editedItem.price_sell = item.price_sell;
      this.edit_colors.hex = item.item_color;
      this.select_group_edit = item.group;
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.items.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_item(frmData2, item.id).then(response => {
            this.loading = false;
            this.items.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.code = this.code;
          this.newItem.group_id = this.select_group.id;
          this.newItem.item_color = this.colors.hex;
          var frmData = new FormData();
          frmData.append("item", JSON.stringify(this.newItem));

          add_item(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_store, this.$options.data().select_store);
            // Object.assign(this.$data.select_group, this.$options.data().select_group);
            this.items.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          this.editedItem.group_id = this.select_group_edit.id;
          this.editedItem.item_color = this.edit_colors.hex;
          var frmData = new FormData();
          frmData.append("item", JSON.stringify(this.editedItem));
          update_item(frmData, item_id).then(response => {
            Vue.set(
              this.items,
              this.items.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
